module.exports = __webpack_public_path__ + "static/media/03.5403d8a2.jpg";